/* ==========================================================================
   Custom Color  ·  Leprecon Plus
   Multicolor swatch for the "Custom Color" option value + a Fancybox popup
   asking for the paint code. No dependencies beyond Fancybox 4.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__ccpLoaded) return;
  window.__ccpLoaded = true;

  /* ---------------------------------------------------------------- styles */

  var STYLES = [
    '.ccp-multiswatch{',
    'background-image:conic-gradient(from 210deg,#ff0026,#ff8a00,#ffe600,#4cff00,#00ffc8,#0084ff,#5b00ff,#e800ff,#ff0026)!important;',
    'background-color:transparent!important;background-size:cover!important;opacity:1!important;}',
    '.ccp-multiswatch::after,.ccp-multiswatch::before{display:none!important;}',

    /* !important on the box: theme cart CSS forces spans back to display:inline,
       which collapses the chip to zero width. */
    '.ccp-chip{display:inline-block!important;width:1.4rem!important;height:1.4rem!important;',
    'border-radius:.3rem;vertical-align:-.2rem;margin:0 .4rem 0 .2rem;',
    'background-color:var(--ccp-chip,#888);background-size:cover;',
    'box-shadow:0 0 0 .1rem rgba(var(--color-foreground,18 18 18),.28);}',
    '.ccp-chip--multi{background-image:conic-gradient(from 210deg,#ff0026,#ff8a00,#ffe600,#4cff00,#00ffc8,#0084ff,#5b00ff,#e800ff,#ff0026);}',
    '.ccp-legend-name{opacity:.75;}',

    /* Fancybox 4 puts .fancybox__content on #ccp-dialog itself, not a wrapper */
    '.ccp-fb .fancybox__content{width:min(94vw,50rem);max-height:92vh;overflow:auto;',
    'padding:2.4rem;border-radius:1rem;',
    'background:rgb(var(--color-background,255 255 255));color:rgb(var(--color-foreground,18 18 18));}',
    '.ccp-fb .carousel__button.is-close{color:rgb(var(--color-foreground,18 18 18));}',
    '.ccp-fb .fancybox__backdrop{backdrop-filter:blur(2px);}',
    'dialog.ccp-native{width:min(94vw,50rem);max-height:92vh;padding:2.4rem;border:0;border-radius:1rem;',
    'background:rgb(var(--color-background,255 255 255));color:rgb(var(--color-foreground,18 18 18));}',
    'dialog.ccp-native::backdrop{background:rgba(0,0,0,.55);}',

    '.ccp-title{margin:0 0 .6rem;font-size:2rem;line-height:1.2;}',
    '.ccp-desc{margin:0 0 1.4rem;font-size:1.4rem;line-height:1.5;opacity:.85;}',
    '.ccp-fee{display:inline-block;margin:0 0 1.8rem;padding:.7rem 1.2rem;border-radius:.6rem;',
    'font-size:1.5rem;font-weight:600;line-height:1;',
    'color:rgb(var(--color-foreground,18 18 18));background:rgba(var(--color-foreground,18 18 18),.07);}',
    '.ccp-field{margin:0 0 1.4rem;}',
    '.ccp-field label{display:block;font-size:1.3rem;margin:0 0 .6rem;}',
    '.ccp-input{width:100%;padding:1.1rem 1.2rem;font-size:1.5rem;font-family:inherit;color:inherit;',
    'background:rgb(var(--color-background,255 255 255));border:.1rem solid rgba(var(--color-foreground,18 18 18),.28);border-radius:.6rem;}',
    '.ccp-input:focus{outline:.2rem solid rgba(var(--color-foreground,18 18 18),.6);outline-offset:.1rem;}',

    /* buttons use the theme's own .button classes; .ccp-btn only handles layout */
    '.ccp-actions{display:flex;gap:1rem;margin:2rem 0 0;flex-wrap:wrap;}',
    '.ccp-btn{flex:1 1 12rem;}',
    '.ccp-note{margin:1rem 0 0;font-size:1.3rem;color:#b3261e;display:none;}',
    '.ccp-note[data-show]{display:block;}'
  ].join('');

  /* --------------------------------------------------------------- storage */

  function key(pid) { return 'ccp:' + pid; }

  function load(pid) {
    try {
      var raw = sessionStorage.getItem(key(pid));
      if (!raw) return null;
      var o = JSON.parse(raw);
      /* tolerate values saved by the older name/hex version */
      var code = o && (o.code || o.name);
      return code ? { code: String(code) } : null;
    } catch (e) { return null; }
  }

  function save(pid, val) {
    try {
      if (val) sessionStorage.setItem(key(pid), JSON.stringify(val));
      else sessionStorage.removeItem(key(pid));
    } catch (e) { /* private mode */ }
  }

  /* ----------------------------------------------------------------- modal */

  var modal = null;

  function buildModal() {
    if (modal) return modal;

    var el = document.createElement('div');
    el.id = 'ccp-dialog';
    el.innerHTML =
      '<h2 class="ccp-title" data-title></h2>' +
      '<p class="ccp-desc" data-desc></p>' +
      '<p class="ccp-fee" data-fee></p>' +
      '<div class="ccp-field">' +
        '<label data-code-label for="ccp-code"></label>' +
        '<input class="ccp-input" type="text" id="ccp-code" data-code autocomplete="off" spellcheck="false">' +
      '</div>' +
      '<p class="ccp-note" data-note></p>' +
      '<div class="ccp-actions">' +
        '<button type="button" class="ccp-btn button button--primary" data-save></button>' +
        '<button type="button" class="ccp-btn button button--secondary" data-cancel></button>' +
      '</div>';

    /* Parked inside a hidden host. Fancybox moves #ccp-dialog into its slide;
       we put it back ourselves on close (see reclaim). */
    var host = document.createElement('div');
    host.id = 'ccp-host';
    host.style.display = 'none';
    host.appendChild(el);
    document.body.appendChild(host);

    var q = function (s) { return el.querySelector(s); };
    var codeEl = q('[data-code]'), noteEl = q('[data-note]');
    var onDone = null, lastFocus = null;
    var isOpen = false, pending = null, nativeDlg = null, closeSeq = 0;
    var requireCode = true, requireMessage = '';

    q('[data-cancel]').addEventListener('click', function () { close(); });

    q('[data-save]').addEventListener('click', function () {
      var code = codeEl.value.trim();
      if (requireCode && !code) {
        noteEl.textContent = requireMessage;
        noteEl.setAttribute('data-show', '');
        codeEl.focus();
        return;
      }
      pending = code ? { code: code } : null;
      close();
    });

    codeEl.addEventListener('input', function () { noteEl.removeAttribute('data-show'); });
    codeEl.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); q('[data-save]').click(); }
    });

    /* Fancybox 4.0.11's animated close path never completes on this theme, so
       instances stay registered and their DOM stays behind — and they pile up
       with every open. instance.destroy() is the teardown that works: it
       removes the container, puts #ccp-dialog back in the host, deregisters
       the instance and unlocks scrolling. Destroy OUR instances only (matched
       by mainClass) so a theme gallery lightbox is never touched. */
    function reclaim() {
      try {
        var cap = 0, inst;
        while (window.Fancybox && (inst = window.Fancybox.getInstance()) && cap++ < 6) {
          var ours = (inst.options && inst.options.mainClass === 'ccp-fb') ||
                     (inst.$container && inst.$container.className.indexOf('ccp-fb') > -1);
          if (!ours) break;
          inst.destroy();
        }
      } catch (e) { if (window.console) console.warn('[ccp]', e); }

      /* manual backstop in case destroy() itself failed */
      if (el.parentNode !== host) {
        el.className = el.className.replace(/\bfancybox[\w-]*/g, '').replace(/\s+/g, ' ').trim();
        host.appendChild(el);
      }
      Array.prototype.forEach.call(
        document.querySelectorAll('.fancybox__container.ccp-fb'),
        function (n) { if (n.parentNode) n.parentNode.removeChild(n); }
      );
      /* Only unlock scrolling if nothing else (e.g. the gallery) is open.
         Fancybox locks scroll with TWO markers: .with-fancybox on <html> and
         .compensate-for-scrollbar on <body>. Leaving the second one behind
         keeps body{overflow:hidden}, which makes the whole page look dead —
         you can't scroll and Add to cart appears not to work. */
      if (!document.querySelector('.fancybox__container')) {
        document.documentElement.classList.remove('with-fancybox');
        document.body.classList.remove('compensate-for-scrollbar');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.documentElement.style.overflow = '';
      }
    }

    function shellOpen() {
      isOpen = true;
      closeSeq++;   /* cancel any reclaim still pending from a previous close */

      if (window.Fancybox) {
        window.Fancybox.show([{ src: '#ccp-dialog', type: 'inline' }], {
          mainClass: 'ccp-fb',
          dragToClose: false,
          autoFocus: false,
          placeFocusBack: true,
          Toolbar: false,
          Thumbs: false,
          /* 'closing' fires immediately; 'destroy' can never arrive */
          on: { closing: finish, destroy: finish }
        });
      } else {
        if (!nativeDlg) {
          nativeDlg = document.createElement('dialog');
          nativeDlg.className = 'ccp-native';
          document.body.appendChild(nativeDlg);
          nativeDlg.addEventListener('close', finish);
        }
        nativeDlg.appendChild(el);
        nativeDlg.showModal();
      }
      setTimeout(function () { codeEl.focus(); codeEl.select(); }, 60);
    }

    function close() {
      if (!isOpen) return;
      if (window.Fancybox && window.Fancybox.getInstance()) {
        window.Fancybox.close();
        setTimeout(finish, 600);   /* finish is idempotent */
        return;
      }
      if (nativeDlg && nativeDlg.open) { nativeDlg.close(); return; }
      finish();
    }

    /* single exit point — Save, Cancel, the Fancybox close button,
       Escape or a backdrop click all land here */
    function finish() {
      if (!isOpen) return;
      isOpen = false;
      var mine = ++closeSeq;
      setTimeout(function () { if (mine === closeSeq) reclaim(); }, 400);
      var result = pending, cb = onDone;
      pending = null; onDone = null;
      if (cb) cb(result);   /* result is null when dismissed without saving */
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function open(cfg, current, done) {
      onDone = done;
      pending = null;
      lastFocus = document.activeElement;
      requireCode = cfg.requireCode;
      requireMessage = cfg.requireMessage;

      q('[data-title]').textContent = cfg.heading;
      q('[data-desc]').textContent = cfg.description;
      q('[data-code-label]').textContent = cfg.inputLabel;
      q('[data-save]').textContent = cfg.saveLabel;
      q('[data-cancel]').textContent = cfg.cancelLabel;
      codeEl.placeholder = cfg.inputPlaceholder;
      codeEl.value = current ? current.code : '';

      var fee = q('[data-fee]');
      fee.textContent = cfg.feeText;
      fee.style.display = cfg.feeText ? '' : 'none';

      noteEl.textContent = cfg.note || '';
      if (cfg.note) noteEl.setAttribute('data-show', ''); else noteEl.removeAttribute('data-show');

      shellOpen();
    }

    modal = { open: open, close: close, isOpen: function () { return isOpen; } };
    return modal;
  }

  /* ------------------------------------------------------------ controller */

  function Controller(root) {
    var d = root.dataset;
    this.root = root;
    this.pid = d.productId;
    this.valueName = d.valueName || 'Custom Color';
    /* not "Custom Color" — Dawn already prints the variant as "Color: Custom Color" */
    this.propName = d.propertyName || 'Paint Code';
    this.requireCode = d.requireCode !== 'false';
    this.cfg = {
      heading: d.heading || 'Custom Color',
      description: d.description || '',
      feeText: d.feeText || '',
      inputLabel: d.inputLabel || 'Enter paint code:',
      inputPlaceholder: d.inputPlaceholder || '',
      saveLabel: d.saveLabel || 'Save',
      cancelLabel: d.cancelLabel || 'Cancel',
      requireCode: this.requireCode,
      requireMessage: d.requireMessage || 'Please enter your paint code.'
    };
    this.value = load(this.pid);
    this.applying = false;
    /* Custom Color add-on product (the snippet sets it only while the add-on
       is available): a Custom Color order then goes to the cart as a standard
       colour of this product + the add-on, not as the Custom Color variant. */
    this.addonId = parseInt(d.addonVariantId, 10) || 0;
    try { this.addonMap = JSON.parse(d.addonMap || '{}') || {}; } catch (e) { this.addonMap = {}; }
    this.productTitle = d.productTitle || '';
    this.addonError = d.addonError || 'Custom Color could not be added to the cart. Please try again.';
    this.busy = false;
    this.init();
  }

  Controller.prototype.section = function () {
    var vs = document.querySelector('variant-selects');
    var sid = (vs && vs.dataset.section) || this.root.dataset.sectionId;
    return (sid && document.getElementById('shopify-section-' + sid)) || document.querySelector('.product') || document.body;
  };

  Controller.prototype.radio = function () {
    var name = this.valueName.toLowerCase();
    var inputs = document.querySelectorAll('.product-form__input input[type="radio"], variant-selects input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if ((inputs[i].value || '').trim().toLowerCase() === name) return inputs[i];
    }
    return null;
  };

  Controller.prototype.fieldset = function (radio) {
    return radio ? (radio.closest('fieldset') || radio.closest('.product-form__input')) : null;
  };

  Controller.prototype.forms = function () {
    return document.querySelectorAll('form[action*="/cart/add"]');
  };

  Controller.prototype.isCustomSelected = function () {
    var r = this.radio();
    if (r) return r.checked;
    var sel = document.querySelector('variant-selects select');
    return !!(sel && (sel.value || '').trim().toLowerCase() === this.valueName.toLowerCase());
  };

  /* ---- swatch + label ---- */

  Controller.prototype.decorateSwatch = function () {
    var r = this.radio();
    if (!r) return;
    var esc = (window.CSS && window.CSS.escape) ? window.CSS.escape(r.id) : r.id;
    var label = document.querySelector('label[for="' + esc + '"]')
             || (r.parentNode && r.parentNode.querySelector('label'));
    if (!label) return;
    var sw = label.querySelector('.swatch');
    if (sw && !sw.classList.contains('ccp-multiswatch')) {
      sw.classList.remove('swatch--unavailable');
      sw.classList.add('ccp-multiswatch');
    }
    if (!label.dataset.ccpBound) {
      label.dataset.ccpBound = '1';
      var self = this;
      label.addEventListener('click', function () {
        setTimeout(function () { self.openModal(); }, 0);   /* let the radio select first */
      });
    }
    label.title = this.value ? this.cfg.heading + ' — ' + this.value.code : this.cfg.heading;
  };

  Controller.prototype.decorateLegend = function () {
    var fs = this.fieldset(this.radio());
    if (!fs) return;
    var legend = fs.querySelector('legend, .form__label');
    if (!legend) return;

    var old = legend.querySelector('.ccp-chip');
    if (old) old.remove();
    var oldName = legend.querySelector('.ccp-legend-name');
    if (oldName) oldName.remove();

    if (!this.isCustomSelected()) return;

    var valueSpan = legend.querySelector('span:not(.ccp-chip):not(.ccp-legend-name)');
    var chip = document.createElement('span');
    chip.className = 'ccp-chip ccp-chip--multi';

    if (valueSpan) {
      valueSpan.parentNode.insertBefore(chip, valueSpan);
      if (this.value) {
        var nm = document.createElement('span');
        nm.className = 'ccp-legend-name';
        nm.textContent = ' — ' + this.value.code;
        valueSpan.parentNode.insertBefore(nm, valueSpan.nextSibling);
      }
    } else {
      legend.appendChild(chip);
    }
  };

  /* ---- cart line item property ---- */

  Controller.prototype.syncForms = function () {
    var self = this;
    var code = (this.value && this.value.code) ? this.value.code : '';
    var active = this.isCustomSelected() && code !== '';

    Array.prototype.forEach.call(this.forms(), function (form) {
      var input = form.querySelector('input[data-ccp-prop="code"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('data-ccp-prop', 'code');
        form.appendChild(input);
      }
      input.name = 'properties[' + self.propName + ']';
      input.value = code;
      input.disabled = !active;   /* disabled inputs are not submitted */

      if (!form.dataset.ccpGuard) {
        form.dataset.ccpGuard = '1';
        /* runs first: swaps Custom Color for a standard colour + the add-on */
        form.addEventListener('submit', function (ev) { self.onSubmitAddon(form, ev); }, true);
        form.addEventListener('submit', function (ev) {
          if (!self.requireCode) return;
          if (self.isCustomSelected() && !(self.value && self.value.code)) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            self.openModal(self.cfg.requireMessage);
          }
        }, true);
      }
    });
  };

  /* ---- Custom Color add-on ---- */

  /* The standard variant that goes to the cart in place of this Custom
     Color variant (same product, same other options). 0 = no add-on flow. */
  Controller.prototype.baseFor = function (variantId) {
    if (!this.addonId) return 0;
    return parseInt(this.addonMap[String(variantId)], 10) || 0;
  };

  Controller.prototype.onSubmitAddon = function (form, ev) {
    if (form.__ccpPass) return; /* our own second submit: let the theme add it */
    if (!this.addonId || !this.isCustomSelected()) return;
    if (!(this.value && this.value.code)) return; /* the paint code guard handles this */
    var idInput = form.querySelector('[name="id"]');
    var customId = idInput ? idInput.value : '';
    var baseId = this.baseFor(customId);
    if (!baseId) return; /* nothing to swap to: add the Custom Color variant as before */
    ev.preventDefault();
    ev.stopImmediatePropagation();
    this.addWithAddon(form, idInput, customId, baseId);
  };

  /* 1. add the Custom Color add-on (paint code + which product it is for),
     2. then let the theme add the caliper covers in a standard colour with
        the same paint code. Both lines share a hidden _ccp_link property so
        the cart keeps them together (see the add-on sync below).
     If step 1 fails, nothing is added and the error is shown. No retry. */
  Controller.prototype.addWithAddon = function (form, idInput, customId, baseId) {
    var self = this;
    var pf = form.closest('product-form');
    var btn = form.querySelector('[type="submit"]');
    if (this.busy || (btn && btn.getAttribute('aria-disabled') === 'true')) return;
    this.busy = true;

    var qty = parseInt(new FormData(form).get('quantity'), 10) || 1;
    var code = this.value.code;
    var link = baseId + '|' + code;
    var spinner = pf ? pf.querySelector('.loading__spinner') : null;

    function loading(on) {
      if (btn) {
        btn.classList.toggle('loading', on);
        if (on) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
      }
      if (spinner) spinner.classList.toggle('hidden', !on);
    }
    function showError(msg) {
      if (pf && typeof pf.handleErrorMessage === 'function' && !pf.hideErrors) pf.handleErrorMessage(msg);
      else self.openModal(msg);
    }

    if (pf && typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage();
    loading(true);
    holdSync(15000); /* the cart is half-built until the theme adds the covers */

    var props = {};
    props[this.propName] = code;
    props.For = this.productTitle;
    props._ccp_link = link;

    postJSON('cart/add.js', { items: [{ id: this.addonId, quantity: qty, properties: props }] })
      .then(function (res) {
        loading(false);
        if (!res || res.status) {
          var err = new Error((res && (res.description || res.message)) || '');
          err.ccp = true;
          throw err;
        }
        var linkInput = form.querySelector('input[data-ccp-prop="link"]');
        if (!linkInput) {
          linkInput = document.createElement('input');
          linkInput.type = 'hidden';
          linkInput.setAttribute('data-ccp-prop', 'link');
          linkInput.name = 'properties[_ccp_link]';
          form.appendChild(linkInput);
        }
        linkInput.value = link;
        cartHasLinked = true;
        linkInput.disabled = false;
        idInput.value = baseId;
        var codeInput = form.querySelector('input[data-ccp-prop="code"]');
        var codeName = codeInput ? codeInput.name : '';
        if (codeInput) codeInput.name = 'properties[_' + self.propName + ']';
        form.__ccpPass = true;
        try {
          if (typeof form.requestSubmit === 'function') {
            if (btn) form.requestSubmit(btn); else form.requestSubmit();
          } else if (btn) {
            btn.click();
          }
        } finally {
          /* the theme read the form synchronously: put the page back */
          form.__ccpPass = false;
          idInput.value = customId;
          linkInput.disabled = true;
          if (codeInput) codeInput.name = codeName;
        }
      })
      .catch(function (e) {
        loading(false);
        holdSync(0);
        if (window.console) console.warn('[ccp]', e);
        showError((e && e.ccp && e.message) || self.addonError);
      })
      .then(function () { self.busy = false; });
  };

  /* ---- modal ---- */

  Controller.prototype.openModal = function (note) {
    var self = this;
    if (modal && modal.isOpen()) return;
    var cfg = Object.assign({}, this.cfg, { note: note || '' });
    buildModal().open(cfg, this.value, function (result) {
      if (!result) {
        /* Cancel, Escape or a backdrop click with nothing saved. Without a paint
           code "Custom Color" cannot be added to the cart, so hand the picker
           back to the first colour instead of leaving it stranded. */
        if (!self.value) self.selectFirstVariant();
        return;
      }
      self.value = result;
      save(self.pid, result);
      self.apply();
    });
  };

  /* Select the first option in the same group as the custom-colour radio
     ("Red" on the caliper products) and let the theme react as if the
     customer had tapped it. The synthetic change event is not trusted, so
     the picker's own listener will not reopen the popup. */
  Controller.prototype.selectFirstVariant = function () {
    var r = this.radio();
    if (r) {
      var fs = this.fieldset(r);
      var radios = fs ? fs.querySelectorAll('input[type="radio"]') : document.querySelectorAll('input[type="radio"][name="' + r.name + '"]');
      var first = radios[0];
      if (!first || first === r) return;
      first.checked = true;
      first.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var sel = document.querySelector('variant-selects select');
    if (sel && sel.options.length && sel.selectedIndex !== 0) {
      sel.selectedIndex = 0;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  /* ---- apply ---- */

  Controller.prototype.apply = function () {
    if (this.applying) return;
    this.applying = true;
    try {
      this.decorateSwatch();
      this.decorateLegend();
      this.syncForms();
    } catch (e) {
      if (window.console) console.warn('[ccp]', e);
    }
    var self = this;
    setTimeout(function () { self.applying = false; }, 0);
  };

  Controller.prototype.init = function () {
    var self = this;
    this.apply();

    /* Dawn re-renders the product info section on every variant change,
       which wipes our DOM edits — re-apply after each render. */
    var t = null;
    new MutationObserver(function () {
      if (self.applying) return;
      clearTimeout(t);
      t = setTimeout(function () { self.apply(); }, 60);
    }).observe(this.section(), { childList: true, subtree: true });

    document.addEventListener('change', function (ev) {
      if (!ev.target || !ev.target.matches) return;
      if (!ev.target.matches('input[type="radio"], select')) return;
      clearTimeout(t);
      t = setTimeout(function () { self.apply(); }, 60);
      /* keyboard users who land on Custom Color still get the popup */
      var chosen = (ev.target.value || '').trim().toLowerCase() === self.valueName.toLowerCase();
      if (chosen && ev.isTrusted && !self.value) {
        setTimeout(function () { if (self.isCustomSelected()) self.openModal(); }, 80);
      }
    });

    /* Hard guard: catch the Add to cart click before any theme handler runs. */
    document.addEventListener('click', function (ev) {
      if (!self.requireCode) return;
      /* This theme lays a .blocking-overlay (its Year/Trim/Logo fitment gate)
         directly over Add to cart, so a real click never reaches the button —
         it hits the overlay, which is a sibling. Match it too, or this guard
         silently never runs. */
      var btn = ev.target.closest && ev.target.closest(
        '.product-form__submit, button[name="add"], button[type="submit"], .blocking-overlay');
      if (!btn || !btn.closest('form[action*="/cart/add"]')) return;
      if (self.isCustomSelected() && !(self.value && self.value.code)) {
        ev.preventDefault();
        ev.stopPropagation();
        self.openModal(self.cfg.requireMessage);
      }
    }, true);
  };

  /* ------------------------------------------------------- cart line items */

  function parseHex(text) {
    var m = String(text == null ? '' : text).trim().match(/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
    if (!m) return null;
    var h = m[1];
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    return '#' + h.toLowerCase();
  }

  var cartApplying = false;

  /* Dawn renders each line's properties as
       <dl><div class="product-option"><dt>Label:</dt><dd>Value</dd></div>…</dl>
     Pairing each dt with its next sibling keeps this agnostic about the
     wrapper, so it works on the cart page, drawer and notification alike.
     Only fires for values that actually are a hex colour — which now means
     carts created by the earlier colour-picker build. */
  function decorateCart() {
    Array.prototype.forEach.call(document.querySelectorAll('dl'), function (dl) {
      Array.prototype.forEach.call(dl.querySelectorAll('dt'), function (dt) {
        var dd = dt.nextElementSibling;
        if (!dd || dd.tagName !== 'DD') return;
        if (dd.querySelector('.ccp-chip')) return;
        var hex = parseHex(dd.textContent);
        if (!hex) return;
        var chip = document.createElement('span');
        chip.className = 'ccp-chip';
        chip.style.setProperty('--ccp-chip', hex);
        chip.title = hex.toUpperCase();
        dd.insertBefore(chip, dd.firstChild);
      });
    });
  }

  function initCart() {
    function run() {
      if (cartApplying) return;
      cartApplying = true;
      try { decorateCart(); }
      catch (e) { if (window.console) console.warn('[ccp cart]', e); }
      setTimeout(function () { cartApplying = false; }, 0);
    }
    run();
    var t = null;
    new MutationObserver(function () {
      if (cartApplying) return;
      clearTimeout(t);
      t = setTimeout(run, 80);
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', run);
  }

  /* --------------------------------------------- Custom Color add-on sync */

  /* A Custom Color order is two cart lines that share a hidden _ccp_link
     property: the caliper covers (standard colour) and the Custom Color
     add-on. Keep them together: the add-on quantity always equals its
     caliper covers quantity, and it goes away with them. A missing add-on
     line is added back once per page view, never in a loop. */

  var ADDON = 0, ADDON_HANDLE = '', PROP = 'Paint Code';
  var syncPromise = null, syncAgain = false, readded = {}, holdUntil = 0, holdTimer = null;
  var cartHasLinked = false, updating = 0, guarding = false, lastQtyChange = 0;

  function routeUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }
  function getJSON(path) {
    return fetch(routeUrl(path), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function postJSON(path, body) {
    return fetch(routeUrl(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function holdSync(ms) { holdUntil = ms ? Date.now() + ms : 0; }
  function isAddon(it) {
    return it.variant_id === ADDON || (!!ADDON_HANDLE && it.handle === ADDON_HANDLE);
  }

  /* Returns a promise that settles when the cart has been checked (and
     fixed if needed). force = ignore the hold set while a product is being
     added (used right before checkout). */
  function syncCart(force) {
    if (!ADDON) return Promise.resolve();
    if (!force && Date.now() < holdUntil) {
      clearTimeout(holdTimer);
      holdTimer = setTimeout(syncCart, holdUntil - Date.now() + 50);
      return Promise.resolve();
    }
    if (syncPromise) { syncAgain = true; return syncPromise; }
    syncAgain = false;
    syncPromise = getJSON('cart.js').then(function (cart) {
      var mains = {}, addons = {}, jobs = [];
      (cart.items || []).forEach(function (it) {
        var link = it.properties && it.properties._ccp_link;
        if (!link) return;
        if (isAddon(it)) { addons[link] = it; return; }
        var m = mains[link] || (mains[link] = { qty: 0, item: it });
        m.qty += it.quantity;
      });
      cartHasLinked = Object.keys(mains).length > 0 || Object.keys(addons).length > 0;
      Object.keys(addons).forEach(function (link) {
        var want = mains[link] ? mains[link].qty : 0;
        if (addons[link].quantity !== want) jobs.push(['cart/change.js', { id: addons[link].key, quantity: want }]);
      });
      Object.keys(mains).forEach(function (link) {
        if (addons[link] || readded[link]) return;
        readded[link] = true;
        var it = mains[link].item, p = {};
        var ip = it.properties || {};
        p[PROP] = ip[PROP] || ip['_' + PROP] || String(link).split('|').slice(1).join('|');
        p.For = it.product_title;
        p._ccp_link = link;
        jobs.push(['cart/add.js', { items: [{ id: ADDON, quantity: mains[link].qty, properties: p }] }]);
      });
      if (!jobs.length) return false;
      return jobs.reduce(function (chain, job) {
        return chain.then(function () { return postJSON(job[0], job[1]); });
      }, Promise.resolve()).then(function () { return true; });
    }).then(function (changed) {
      if (changed) return rerenderCart();
    }).catch(function (e) {
      if (window.console) console.warn('[ccp cart]', e);
    }).then(function () {
      syncPromise = null;
      if (syncAgain) return syncCart(force);
    });
    return syncPromise;
  }

  /* Redraw the cart drawer / cart page the same way the theme does after a
     quantity change (each cart element lists its own sections). */
  function rerenderCart() {
    var list = [];
    ['cart-items', 'cart-drawer-items'].forEach(function (tag) {
      var host = document.querySelector(tag);
      if (!host || typeof host.getSectionsToRender !== 'function') return;
      try {
        host.getSectionsToRender().forEach(function (s) {
          if (!list.some(function (x) { return x.id === s.id; })) list.push(s);
        });
      } catch (e) { /* section missing on this page */ }
    });
    if (!list.some(function (x) { return x.id === 'cart-icon-bubble'; }) && document.getElementById('cart-icon-bubble')) {
      list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }
    var names = [];
    list.forEach(function (s) { if (names.indexOf(s.section) < 0) names.push(s.section); });
    if (!names.length) return Promise.resolve();
    return Promise.all([
      getJSON('cart.js'),
      fetch(window.location.pathname + '?sections=' + names.join(','), { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var empty = !res[0].item_count, secs = res[1] || {};
      list.forEach(function (s) {
        var host = document.getElementById(s.id), html = secs[s.section];
        if (!host || !html) return;
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
        if (src) (host.querySelector(s.selector) || host).innerHTML = src.innerHTML;
      });
      ['cart-items', 'cart-drawer-items', 'cart-drawer'].forEach(function (tag) {
        var el = document.querySelector(tag);
        if (el) el.classList.toggle('is-empty', empty);
      });
      var footer = document.getElementById('main-cart-footer');
      if (footer) footer.classList.toggle('is-empty', empty);
    });
  }

/* ---- cart quantity changes: covers + add-on in ONE request ---- */

  /* Cart rows of a Custom Color order carry data-ccp-link / -key / -qty
     (and data-ccp-addon on the add-on). Changing the caliper covers sends
     both new quantities in a single cart/update.js call, so the add-on
     never lags behind, not even for the second the cart takes to redraw. */
  function linkedUpdates(host, line, quantity) {
    if (!ADDON) return null;
    var row = host.querySelector('#CartItem-' + line + ', #CartDrawer-Item-' + line);
    var link = row && row.getAttribute('data-ccp-link');
    var q = parseInt(quantity, 10);
    if (!link || row.hasAttribute('data-ccp-addon') || isNaN(q) || q < 0) return null;
    var addonRow = null, total = 0;
    Array.prototype.forEach.call(host.querySelectorAll('[data-ccp-link]'), function (r) {
      if (r.getAttribute('data-ccp-link') !== link) return;
      if (r.hasAttribute('data-ccp-addon')) { addonRow = r; return; }
      total += r === row ? q : (parseInt(r.getAttribute('data-ccp-qty'), 10) || 0);
    });
    if (!addonRow) return null;
    var updates = {};
    updates[row.getAttribute('data-ccp-key')] = q;
    updates[addonRow.getAttribute('data-ccp-key')] = total;
    return updates;
  }

  /* Same steps as the theme's CartItems.updateQuantity, with update.js */
  function updateLinked(host, line, updates, variantId) {
    var sections = host.getSectionsToRender();
    host.enableLoading(line);
    updating++;
    return postJSON('cart/update.js', {
      updates: updates,
      sections: sections.map(function (s) { return s.section; }),
      sections_url: window.location.pathname
    }).then(function (state) {
      if (!state || state.status || state.errors) {
        var input = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
        if (input) input.value = input.getAttribute('value');
        try {
          host.updateLiveRegions(line, (state && (state.errors || state.description || state.message)) || (window.cartStrings && window.cartStrings.error) || '');
        } catch (e) { /* no live region */ }
        return;
      }
      var empty = state.item_count === 0;
      host.classList.toggle('is-empty', empty);
      var drawer = document.querySelector('cart-drawer'), footer = document.getElementById('main-cart-footer');
      if (footer) footer.classList.toggle('is-empty', empty);
      if (drawer) drawer.classList.toggle('is-empty', empty);
      sections.forEach(function (s) {
        var el = document.getElementById(s.id), html = state.sections && state.sections[s.section];
        if (!el || !html) return;
        (el.querySelector(s.selector) || el).innerHTML = host.getSectionInnerHTML(html, s.selector);
      });
      try { host.updateLiveRegions(line, ''); } catch (e) { /* no live region */ }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state, variantId: variantId });
      }
    }).catch(function (e) {
      if (window.console) console.warn('[ccp cart]', e);
      var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
    }).then(function () {
      updating--;
      host.disableLoading(line);
    });
  }

  function patchCartItems() {
    function patch() {
      var CI = customElements.get('cart-items');
      if (!CI || CI.prototype.__ccpPatched) return;
      var original = CI.prototype.updateQuantity;
      CI.prototype.__ccpPatched = true;
      CI.prototype.updateQuantity = function (line, quantity, name, variantId) {
        var updates = linkedUpdates(this, line, quantity);
        if (!updates) return original.apply(this, arguments);
        return updateLinked(this, line, updates, variantId);
      };
    }
    if (customElements.get('cart-items')) patch();
    else if (customElements.whenDefined) customElements.whenDefined('cart-items').then(patch);
  }

  /* ---- checkout guard ---- */

  /* Before leaving for checkout: let a quantity change that is still
     waiting (the theme waits 300 ms after a change) or in flight finish,
     check the cart once more, then continue to checkout as normal. */
  function idle() {
    var start = Date.now();
    return new Promise(function (resolve) {
      (function check() {
        var now = Date.now();
        var busy = updating > 0 || !!syncPromise || now - lastQtyChange < 450 ||
          !!document.querySelector('.cart__items--disabled');
        if (!busy || now - start > 8000) resolve();
        else setTimeout(check, 80);
      })();
    });
  }

  /* the add-on's quantity box (hidden) is posted with the cart form */
  function fixAddonInputs(form) {
    var sums = {}, addons = [];
    Array.prototype.forEach.call(form.querySelectorAll('[data-ccp-link]'), function (r) {
      var input = r.querySelector('input[name="updates[]"]');
      if (!input) return;
      var link = r.getAttribute('data-ccp-link');
      if (r.hasAttribute('data-ccp-addon')) { addons.push([link, input]); return; }
      sums[link] = (sums[link] || 0) + (parseInt(input.value, 10) || 0);
    });
    addons.forEach(function (a) { a[1].value = sums[a[0]] || 0; });
  }

  function initCheckoutGuard() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'updates[]') lastQtyChange = Date.now();
    }, true);
    document.addEventListener('submit', function (ev) {
      var form = ev.target, btn = ev.submitter;
      if (!form || form.tagName !== 'FORM') return;
      if (form.__ccpOk) { form.__ccpOk = false; return; } /* checked: go */
      if (!btn || btn.name !== 'checkout') return;
      if (!cartHasLinked && !document.querySelector('[data-ccp-link]')) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      if (guarding) return;
      guarding = true;
      var formId = form.id;
      btn.classList.add('ccp-wait');
      idle().then(function () { return syncCart(true); }).catch(function () {}).then(function () {
        guarding = false;
        /* the cart may have been redrawn: find the form and button again */
        var f = (formId && document.getElementById(formId)) || (form.isConnected ? form : null);
        var b = f && (f.querySelector('[name="checkout"]') ||
          (formId && document.querySelector('[name="checkout"][form="' + formId + '"]')));
        if (!f || !b) { window.location.href = routeUrl('checkout'); return; }
        fixAddonInputs(f);
        f.__ccpOk = true;
        if (typeof f.requestSubmit === 'function') f.requestSubmit(b);
        else b.click();
      });
    }, true);
  }

  function initCartSync(root) {
    ADDON = parseInt(root.dataset.addonVariantId, 10) || 0;
    ADDON_HANDLE = root.dataset.addonHandle || '';
    PROP = root.dataset.propertyName || PROP;
    if (!ADDON) return;
    cartHasLinked = root.dataset.ccpCart === 'true';
    patchCartItems();
    initCheckoutGuard();
    var t = null;
    function soon() { clearTimeout(t); t = setTimeout(syncCart, 200); }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === 'ccp') return;
        holdSync(0);
        soon();
      });
      if (PUB_SUB_EVENTS.cartError) {
        subscribe(PUB_SUB_EVENTS.cartError, function () { holdSync(0); soon(); });
      }
    }
    /* page opened with a Custom Color order in the cart */
    if (root.dataset.ccpCart === 'true') soon();
  }

  /* ------------------------------------------------------------------ boot */

  function boot() {
    /* Kill switch. Add ?ccp=off to any URL to load the page with this script
       fully disabled — lets you A/B a problem on the live theme without
       editing or unpublishing anything. */
    if (/[?&]ccp=off(&|$)/.test(location.search)) return;

    var roots = document.querySelectorAll('[data-ccp]');
    if (!roots.length) return;

    if (!document.getElementById('ccp-styles')) {
      var st = document.createElement('style');
      st.id = 'ccp-styles';
      st.textContent = STYLES;
      document.head.appendChild(st);
    }

    Array.prototype.forEach.call(roots, function (r) {
      if (r.dataset.ccpInit) return;
      r.dataset.ccpInit = '1';
      new Controller(r);
    });

    if (!window.__ccpCartInit) {
      window.__ccpCartInit = true;
      initCart();
      initCartSync(roots[0]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();